import {
  VStack,
  Text,
  Image,
  useTheme,
  HStack,
  Box,
  Divider,
} from 'native-base';

import { Affiliate } from '../../types';

const aybleHeathLogo = '../../FA__ayble_health_Logo_Isabelline.png';

const EnterpriseCobranding = ({
  affiliate = null,
}: {
  affiliate: Affiliate | null;
}) => {
  const { logo: affiliateLogo, utm_source: affiliateUtmSource } =
    affiliate || {};
  const {
    colors: { muted, secondary },
  } = useTheme();

  const styles = {
    divider: {
      backgroundColor: muted['500'],
    },
    image: {
      backgroundSize: 'contain',
      maxHeight: '150px',
      fill: secondary['300'],
    },
  };

  return (
    <div style={affiliateLogo ? undefined : { paddingLeft: '24px' }}>
      <VStack>
        {!!affiliateLogo && <Text fontWeight={'normal'}>INTRODUCING</Text>}
        <HStack>
          <Box
            alignItems={'center'}
            flexDir={'row'}
            height={affiliateLogo ? 128 : 150}
            justifyContent={'space-between'}
            maxH={150}
            maxWidth={affiliateLogo ? 500 : null}
            overflow="hidden"
            position={'relative'}
            w={affiliateLogo ? '100%' : null}
            zIndex={1}
          >
            <Image
              width={affiliateLogo ? '140' : '280'}
              height={affiliateLogo ? '80' : '160'}
              source={{
                uri: aybleHeathLogo,
              }}
              resizeMode={'contain'}
              alt="Ayble Health Logo"
              testID={'ayble-health-logo'}
            />
            {affiliateLogo && (
              <>
                <Divider
                  thickness={2}
                  mx={8}
                  orientation={'vertical'}
                  bgColor={muted['500']}
                  testID={'enterprise-cobranding-divider'}
                />
                <Image
                  size={'xl'}
                  source={{
                    uri: affiliateLogo,
                  }}
                  resizeMode={'contain'}
                  style={styles.image}
                  alt={`${affiliateUtmSource} logo`}
                  testID={'affiliate-logo'}
                />
              </>
            )}
          </Box>
        </HStack>
      </VStack>
    </div>
  );
};

export default EnterpriseCobranding;
